import { defineNuxtPlugin } from '#imports'
import { VueQueryPlugin } from '@tanstack/vue-query'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries:
          process.env.NODE_ENV === 'development'
            ? {
                staleTime: 5 * 1000, // local 개발 시에 staleTime이 길면 code 수정 후 hot reload 시 캐시된 API data로 인해 refresh가 안되는 문제가 있음
                gcTime: 5 * 1000,
                refetchOnWindowFocus: false,
                retry: false,
              }
            : {
                staleTime: 5 * 60 * 1000, // no further request in 5 minutes. cache default lifetime.
                retry: false,
              },
      },
    },
  })
})
